(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "true": "True",
  "false": "False"
};
exports["default"] = _default;

},{}],2:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _DotNetStrings = _interopRequireDefault(require("../../Common/Helpers/DotNetStrings"));

"use strict";

(function () {
  var state = {
    elements: {
      selectPortalGroup: null,
      portalGroupOptionsDatalist: null,
      noPortalGroupSelectedWrapper: null,
      invalidPortalGroupSelectedWrapper: null,
      childPortalGroupSelectedWrapper: null,
      portalGroupSelectedWrapper: null,
      selectedPortalGroupName: null,
      selectedPortalGroupSubLabelAHasData: null,
      selectedPortalGroupSubLabelAHasNoData: null,
      selectedPortalGroupSubLabelBHasData: null,
      selectedPortalGroupSubLabelBHasNoData: null,
      selectedPortalGroupResultInput: null
    },
    isSubLabelAHidden: true,
    isSubLabelBHidden: true,
    result: {
      id: null,
      subLabelA: null,
      subLabelB: null,
      name: null,
      isInvalid: null,
      isChild: null
    },
    portalGroupOptionEls: []
  };
  var actions = {
    init: function init() {
      state.elements.selectPortalGroup = document.querySelector("#selectPortalGroup");
      state.elements.portalGroupOptionsDatalist = document.querySelector("#portalGroupOptions");
      state.elements.noPortalGroupSelectedWrapper = document.querySelector("[data-spg-no-selection]");
      state.elements.invalidPortalGroupSelectedWrapper = document.querySelector("[data-spg-invalid-selection]");
      state.elements.childPortalGroupSelectedWrapper = document.querySelector("[data-spg-child-selection]");
      state.elements.portalGroupSelectedWrapper = document.querySelector("[data-spg-selection]");
      state.elements.selectedPortalGroupName = document.querySelector("[data-spg-name]");
      state.elements.selectedPortalGroupSubLabelAHasData = document.querySelector("[data-spg-sub-label-a] [data-has-data]");
      state.elements.selectedPortalGroupSubLabelAHasNoData = document.querySelector("[data-spg-sub-label-a] [data-no-data]");
      state.elements.selectedPortalGroupSubLabelBHasData = document.querySelector("[data-spg-sub-label-b] [data-has-data]");
      state.elements.selectedPortalGroupSubLabelBHasNoData = document.querySelector("[data-spg-sub-label-b] [data-no-data]");
      state.elements.selectedPortalGroupResultInput = document.querySelector("[data-spg-selected-id]");
      state.elements.selectPortalGroup.addEventListener("input", events.selectPortalGroup.input);

      if (state.elements.selectedPortalGroupSubLabelAHasData) {
        state.isSubLabelAHidden = false;
      }

      if (state.elements.selectedPortalGroupSubLabelBHasData) {
        state.isSubLabelBHidden = false;
      }
    },
    presentSelectedPortalGroup: function presentSelectedPortalGroup() {
      var selectedPgResultInput = state.elements.selectedPortalGroupResultInput;
      var value = selectedPgResultInput.value;

      if (value) {
        var result = actions.getPortalGroupDetailById(value);
        actions.resetGroupDetailWidget();
        actions.updateGroupDetailWidget(result);
      }
    },
    updateSelectedGroupDetails: function updateSelectedGroupDetails(selectedValue) {
      var result = actions.getPortalGroupDetailByLabel(selectedValue);
      actions.resetGroupDetailWidget();
      state.elements.selectedPortalGroupResultInput.value = "";
      actions.updateGroupDetailWidget(result);
    },
    updateGroupDetailWidget: function updateGroupDetailWidget(result) {
      if (!result.id) {
        console.warn("The selected Portal group doesn't have an id.");
        return;
      }

      if (result.isChild) {
        state.elements.childPortalGroupSelectedWrapper.classList.remove("d-none");
        state.elements.noPortalGroupSelectedWrapper.classList.add("d-none");
        return;
      }

      if (result.isInvalid) {
        state.elements.invalidPortalGroupSelectedWrapper.classList.remove("d-none");
        state.elements.noPortalGroupSelectedWrapper.classList.add("d-none");
        return;
      }

      state.elements.selectedPortalGroupResultInput.value = result.id;
      state.elements.selectedPortalGroupName.innerHTML = result.name;

      if (!state.isSubLabelAHidden) {
        state.elements.selectedPortalGroupSubLabelAHasData.innerHTML = result.subLabelA;

        if (result.subLabelA) {
          state.elements.selectedPortalGroupSubLabelAHasData.classList.remove("d-none");
          state.elements.selectedPortalGroupSubLabelAHasNoData.classList.add("d-none");
        } else {
          state.elements.selectedPortalGroupSubLabelAHasData.classList.add("d-none");
          state.elements.selectedPortalGroupSubLabelAHasNoData.classList.remove("d-none");
        }
      }

      if (!state.isSubLabelBHidden) {
        state.elements.selectedPortalGroupSubLabelBHasData.innerHTML = result.subLabelB;

        if (result.subLabelB) {
          state.elements.selectedPortalGroupSubLabelBHasData.classList.remove("d-none");
          state.elements.selectedPortalGroupSubLabelBHasNoData.classList.add("d-none");
        } else {
          state.elements.selectedPortalGroupSubLabelBHasData.classList.add("d-none");
          state.elements.selectedPortalGroupSubLabelBHasNoData.classList.remove("d-none");
        }
      }

      state.elements.noPortalGroupSelectedWrapper.classList.add("d-none");
      state.elements.portalGroupSelectedWrapper.classList.remove("d-none");
    },
    resetGroupDetailWidget: function resetGroupDetailWidget() {
      state.elements.selectedPortalGroupName.innerHTML = "";

      if (!state.isSubLabelAHidden) {
        state.elements.selectedPortalGroupSubLabelAHasData.innerHTML = "";
        state.elements.selectedPortalGroupSubLabelAHasData.classList.add("d-none");
        state.elements.selectedPortalGroupSubLabelAHasNoData.classList.remove("d-none");
      }

      if (!state.isSubLabelBHidden) {
        state.elements.selectedPortalGroupSubLabelBHasData.innerHTML = "";
        state.elements.selectedPortalGroupSubLabelBHasData.classList.add("d-none");
        state.elements.selectedPortalGroupSubLabelBHasNoData.classList.remove("d-none");
      }

      state.elements.noPortalGroupSelectedWrapper.classList.remove("d-none");
      state.elements.portalGroupSelectedWrapper.classList.add("d-none");
      state.elements.invalidPortalGroupSelectedWrapper.classList.add("d-none");
      state.elements.childPortalGroupSelectedWrapper.classList.add("d-none");
    },
    resetResult: function resetResult() {
      state.result.id = null;
      state.result.subLabelA = null;
      state.result.subLabelB = null;
      state.result.name = null;
      state.result.isInvalid = null;
      state.result.isChild = null;
    },
    getPortalGroupDetailById: function getPortalGroupDetailById(selectedId) {
      actions.resetResult();
      actions.setPortalGroupOptionEls();
      state.portalGroupOptionEls.forEach(function (optionEl) {
        var id = optionEl.getAttribute("data-id");

        if (id === selectedId) {
          actions.setResult(optionEl);
          return;
        }
      });
      return state.result;
    },
    getPortalGroupDetailByLabel: function getPortalGroupDetailByLabel(selectedValue) {
      actions.resetResult();
      actions.setPortalGroupOptionEls();
      state.portalGroupOptionEls.forEach(function (optionEl) {
        var value = optionEl.value;

        if (value === selectedValue) {
          actions.setResult(optionEl);
          return;
        }
      });
      return state.result;
    },
    setResult: function setResult(optionEl) {
      state.result.id = optionEl.getAttribute("data-id");
      state.result.subLabelA = optionEl.getAttribute("data-sub-label-a");
      state.result.subLabelB = optionEl.getAttribute("data-sub-label-b");
      state.result.name = optionEl.value;
      state.result.isInvalid = optionEl.getAttribute("data-is-invalid-selection") === _DotNetStrings["default"]["true"];
      state.result.isChild = optionEl.getAttribute("data-is-child-portal-group") === _DotNetStrings["default"]["true"];
    },
    setPortalGroupOptionEls: function setPortalGroupOptionEls() {
      if (state.portalGroupOptionEls.length) {
        return;
      }

      state.portalGroupOptionEls = state.elements.portalGroupOptionsDatalist.querySelectorAll("option");
    }
  };
  var events = {
    document: {
      ready: function ready() {
        actions.init();
        actions.presentSelectedPortalGroup();
      }
    },
    selectPortalGroup: {
      input: function input(evt) {
        var selectedValue = evt.target.value;

        if (selectedValue) {
          actions.updateSelectedGroupDetails(evt.target.value);
          return;
        }

        console.warn("User hasn't selected anything in the datalist.");
      }
    }
  };
  document.addEventListener("DOMContentLoaded", events.document.ready);
})();

},{"../../Common/Helpers/DotNetStrings":1,"@babel/runtime/helpers/interopRequireDefault":3}],3:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}]},{},[2]);
